import React from 'react';
import { Separator } from '@components/ui/separator';

interface SectionHeaderProps {
    label: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ label }) => (
    <div className="mt-6 flex items-center gap-3">
        <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {label}
        </span>
        <Separator className="flex-1" />
    </div>
);
